import type { ZustandLocalStorageState } from '../zustand';

export type UserPreferencesLocalStorage = {
  sidebarIsOpened: boolean;
};
export type PasswordResetLinkLocalStorage = {
  email: string;
  linkSentAt: string;
};

export class LocalStorageService {
  public static KEYS = {
    userPreferences: 'user-preferences',
    passwordResetLink: 'password-reset-link',
    lastLoginEmail: 'last-login-email',
    theme: 'theme',
  } as const;

  private static get<T>(key: keyof typeof this.KEYS): T | null {
    const item = localStorage.getItem(key);
    if (item) {
      return JSON.parse(item) as T;
    }
    return null;
  }
  private static set(key: keyof typeof this.KEYS, value: unknown): void {
    localStorage.setItem(key, JSON.stringify(value));
  }
  private static remove(key: keyof typeof this.KEYS): void {
    localStorage.removeItem(key);
  }

  public static getUserPreferences() {
    return this.get<ZustandLocalStorageState<UserPreferencesLocalStorage>>(
      'userPreferences'
    )?.state;
  }

  public static setPasswordResetLink(data: PasswordResetLinkLocalStorage) {
    this.set('passwordResetLink', data);
  }
  public static getPasswordResetLink() {
    return this.get<PasswordResetLinkLocalStorage>('passwordResetLink');
  }
  public static removePasswordResetLink() {
    this.remove('passwordResetLink');
  }

  public static setLastLoginEmail(email: string) {
    this.set('lastLoginEmail', email);
  }
  public static getLastLoginEmail() {
    return this.get<string>('lastLoginEmail');
  }

  public static setTheme(theme: string) {
    this.set('theme', theme);
  }
  public static getTheme() {
    return this.get<string>('theme');
  }
}
